import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLegacyAutomationRedirectViewLogRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-redirect-viewlog',
	path: '/projects/:projectKey/settings/automation/log/:ruleId',
};
